// src/Vouchers.js

import React from 'react';
import { Box, Paper, Typography, Divider } from '@mui/material';
// import logoAABB from './logo-aabb.png'; // Para usar, adicione o arquivo na pasta 'src' e descomente

// Funções de formatação
const formatarData = (dataString) => {
  if (!dataString) return '--/--/----';
  const [ano, mes, dia] = dataString.split('-');
  return `${dia}/${mes}/${ano}`;
};

const VoucherCard = ({ nome, chale, periodo }) => (
    <Paper 
        variant="outlined" 
        sx={{ 
            width: '10cm',
            height: '7cm',
            p: 2, 
            display: 'flex', 
            flexDirection: 'column',
            justifyContent: 'space-between',
            boxSizing: 'border-box',
            pageBreakInside: 'avoid', // Evita que o card seja cortado ao imprimir
        }}
    >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>
                <Typography variant="caption" sx={{ fontWeight: 'bold' }}>AABB ARACAJU</Typography>
                <Typography variant="h6" sx={{ lineHeight: 1.2, mt: 0.5, fontWeight: 'bold' }}>VOUCHER DE ACESSO</Typography>
            </Box>
            {/* Se você tiver um logo, adicione o arquivo na pasta 'src' e descomente a linha abaixo */}
            {/* <img src={logoAABB} alt="Logo AABB" style={{ width: '40px', height: '40px' }} /> */}
        </Box>
        
        <Box>
            <Typography variant="body2">Hóspede:</Typography>
            <Typography variant="body1" sx={{ fontWeight: 500 }}>{nome}</Typography>
        </Box>

        <Box sx={{ borderTop: '1px dashed grey', pt: 1, mt: 1 }}>
            <Typography variant="body2">
                Chalé: <Box component="span" sx={{ fontWeight: 'bold' }}>{chale}</Box>
            </Typography>
            <Typography variant="body2">
                Período: <Box component="span" sx={{ fontWeight: 'bold' }}>{periodo}</Box>
            </Typography>
        </Box>
    </Paper>
);

const Vouchers = ({ reserva, hospede }) => {
  if (!reserva || !hospede) {
    return <Typography>Dados insuficientes para gerar os vouchers.</Typography>;
  }

  const todosHospedes = [
    hospede.nome,
    ...(reserva.acompanhantes || []).map(ac => ac.nome).filter(nome => nome)
  ];

  const periodoEstadia = `${formatarData(reserva.dataCheckin)} a ${formatarData(reserva.dataCheckout)}`;

  return (
    // --- CORREÇÃO PRINCIPAL APLICADA AQUI ---
    <Paper sx={{ p: 2, color: 'black', backgroundColor: 'white' }}>
        <Typography variant="h6" align="center" gutterBottom>
            Vouchers para a Reserva de {hospede.nome}
        </Typography>
        <Typography variant="body2" align="center" color="text.secondary" sx={{ mb: 2 }}>
            Página com {todosHospedes.length} voucher(s). Recorte nas marcações.
        </Typography>
        <Divider />
        <Box sx={{ mt: 2, display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'center' }}>
            {todosHospedes.map((nome, index) => (
                <VoucherCard 
                    key={index}
                    nome={nome}
                    chale={reserva.chaleNome}
                    periodo={periodoEstadia}
                />
            ))}
        </Box>
    </Paper>
  );
};

export default Vouchers;